import { useMemo } from 'react'
import { useClientPreferences } from '../../context/useClientPreferences'
import type { DigestCadence } from '../../types/schema'
import {
  SettingsChoiceGrid,
  type SettingsChoiceOption,
  SettingsRow,
  useInstantSettingRows,
} from '../Common'
import { useNls } from '../../nls/nlsProvider'

export const DigestPreferencesPanel = () => {
  const { t } = useNls()
  const { preferences, updatePreferences } = useClientPreferences()
  const cadence = preferences.digestCadence
  const instantRows = useInstantSettingRows()

  const cadenceOptions: SettingsChoiceOption[] = useMemo(
    () => [
      {
        id: 'DAILY',
        label: t('NLSSettingsDigestCadenceDaily'),
        description: t('NLSSettingsDigestCadenceDailyHint'),
      },
      {
        id: 'WEEKLY',
        label: t('NLSSettingsDigestCadenceWeekly'),
        description: t('NLSSettingsDigestCadenceWeeklyHint'),
      },
    ],
    [t],
  )

  const handleCadenceSelect = (next: DigestCadence) => {
    void instantRows.run('digestCadence', () => updatePreferences({ digestCadence: next }))
  }

  return (
    <div
      className="digestPrefsPanel"
      aria-label={t('NLSSettingsAriaDigestAndQuietHoursPreferences')}
    >
      <SettingsRow
        stacked
        label={t('NLSSettingsLabelDigestCadence')}
        hint={t('NLSSettingsHintDigestCadence')}
        status={instantRows.statusFor('digestCadence')}
        control={
          <SettingsChoiceGrid
            options={cadenceOptions}
            value={cadence}
            onChange={(id) => handleCadenceSelect(id as DigestCadence)}
          />
        }
      />
      {/* Responsive layout reference: repeat(auto-fit, minmax(130px, 1fr)) */}
    </div>
  )
}
